import React, { SyntheticEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TextInput, Dropdown } from 'components'
import { IconClose, IconSearch } from 'components/Icons'
import type { OptionProps } from 'types'
import { useSearchParams } from 'helpers/hooks'

import { STATUS_OPTIONS } from 'helpers/constants/common'
import { onEnter, findSelected } from 'helpers/common'

function ProductCategorySearchAndFilter(): JSX.Element {
  const [searchParams, setSearchParams] = useSearchParams()
  const { t } = useTranslation('productCategory')

  const q: string = searchParams?.q || ''

  const [search, setSearch] = useState<string>(q)
  const selected =
    findSelected(STATUS_OPTIONS, searchParams?.isActive) || STATUS_OPTIONS[1]

  const handleStatusChange = (status: OptionProps): void => {
    const nextStatus = status.key
    setSearchParams({ isActive: nextStatus, _page: 1 })
  }

  const _handleChange = (e: SyntheticEvent) => {
    e.preventDefault()

    const target = e.target as HTMLInputElement

    setSearch(target.value)
  }

  const handleClear = (): void => {
    setSearchParams({ q: '', _page: 1 })
    setSearch('')
  }

  const handleSubmit = (): void => {
    setSearchParams({ q: search.trim(), _page: 1 })
  }

  return (
    <div className='f-company-row'>
      <TextInput
        placeholder={t('productCategory.search.placeholder')}
        variants='secondary'
        name='search'
        onChange={_handleChange}
        value={search}
        onKeyDown={onEnter(handleSubmit)}
        withIcon={
          q && q === search ? (
            <span className='f-company-row__btn-search' onClick={handleClear}>
              <IconClose variants='sm' />
            </span>
          ) : (
            <span className='f-company-row__btn-search' onClick={handleSubmit}>
              <IconSearch variants='sm' />
            </span>
          )
        }
      />
      <Dropdown
        options={STATUS_OPTIONS}
        variants='secondary'
        selected={selected}
        onChange={(item) => handleStatusChange(item)}
        label={t('productCategory.dropdown.placeholder')}
      />
    </div>
  )
}

export default ProductCategorySearchAndFilter
